<template>
  <div id="venue">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toHref()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        场馆预约
        <!-- <img src="@/assets/logo.png" width="21" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>-->
      </div>
      <div class="right">
        <!-- <van-icon name="manager" size="21" /> -->
      </div>
    </div>
    <!-- <div class="top-img">
      <img src="@/assets/venue-top.png" />
    </div>-->
    <ul class="dai">
      <li v-bind:class="{current: num2 == 1}" v-on:click="change2(1)">
        <span style="position: relative;">场馆预约</span>
        <van-icon v-if="num2==1" name="arrow-down" size="20" style="top: 3px;left: 5px" />
      </li>
      <li v-bind:class="{current: num2==2}" v-on:click="change2(2)">
        <span style="position: relative;">场馆展示</span>
        <van-icon v-if="num2==2" name="arrow-down" size="20" style="top: 3px;left: 5px" />
      </li>
    </ul>

    <div class="content">
      <transition name="fade">
        <div v-if="num2 == 1">
          <inlineCalendar
            @switch="handleSwitch"
            :minDate="dates"
            @change="onChange"
            ref="calendar"
          />
          <div class="date">{{this.date}}</div>
          <div class="venue-main">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
              <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <div class="venue-list" v-for="(item,index) in news" :key="index">
                  <div class="venue-list-img">
                    <img :src="item.picture" />
                  </div>
                  <div class="venue-list-text">
                    <div class="venue-list-tit">{{item.name}}</div>
                    <div class="venue-list-info">{{item.description}}</div>
                    <div
                      class="venue-list-btn"
                      v-if="item.a_status==1&&item.m_status==1"
                      @click="toOrder(item.id)"
                    >全天可约</div>
                    <div
                      class="venue-list-btn ban"
                      v-if="item.a_status==0&&item.m_status==1"
                      @click="toOrder(item.id)"
                    >上午可约</div>
                    <div
                      class="venue-list-btn ban"
                      v-if="item.a_status==1&&item.m_status==0"
                      @click="toOrder(item.id)"
                    >下午可约</div>
                    <div class="venue-list-btn red" v-if="item.a_status==0&&item.m_status==0">已约满</div>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
          <div class="yu-btn" @click="toUrl('/record')">
            <div>查看预约</div>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div class="showChang" v-if="num2 == 2">
          <van-pull-refresh v-model="isLoading2" @refresh="onRefresh2" success-text="刷新成功">
            <van-list
              v-model="loading2"
              :finished="finished2"
              finished-text="没有更多了"
              @load="onLoad2"
            >
              <div class="showChang">
                <div
                  class="changList"
                  v-for="(item,index) in news2"
                  :key="index"
                  @click="toInfo(item.id,2)"
                >
                  <div class="changList-img">
                    <img :src="item.picture" />
                  </div>
                  <div class="changList-tit">{{item.name}}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
// import {calendar,inlineCalendar} from 'vue-mobile-calendar';
import { Icon, PullRefresh, List } from "vant";
import {
  venueList,
  getTokenByTicket,
  toknStatus,
  reserve,
} from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    // [Calendar.name]: Calendar,
    // [inlineCalendar.name]: inlineCalendar
  },
  data() {
    return {
      news: [],
      isLoading: false,
      totalPages: 1,
      padding: false,
      loading: false,
      finished: false,
      page: 0,
      news2: [],
      isLoading2: false,
      totalPages2: 1,
      padding2: false,
      loading2: false,
      finished2: false,
      page2: 0,
      show: true,
      num2: 1,
      mode: "single",
      date: this.getNowFormatDate(),
      dates: this.getNowFormatDate(),
      ticket: "",
      token: "",
      chatUrl:"https://qshcjr.ncscloudmedia.com/api.php"
      // chatUrl:"http://cjr.cn/api.php"
    };
  },
  mounted() {
    let ticket = this.$route.query.ticket;
    let token = localStorage.getItem("tokenY");
          // localStorage.setItem("tokenY", 44);
    if (ticket) {
      this.ticket = ticket;
      this.getTokenByTickets();
      this.$router.push("/venue");
    } else if (token) {
      this.token = token;
      this.IsTokenStatus(token);
    } else {
      var href = escape(window.location.href);
      var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
      window.location.href = url;
    }
    this.handleSwitch(this.$refs.calendar.showDate);
  },
  methods: {
    // // 获取token
    getTokenByTickets() {
      //  alert(this.ticket)
      getTokenByTicket({ ticket: this.ticket }).then((res) => {
        if (res.status == 1) {
          localStorage.setItem("tokenY", res.data.token);
          this.token = res.data.token;
        } else {
          this.$router.push("/venue");
          var href = escape(window.location.href);
          var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
          window.location.href = url;
        }
      });
    },
    // token是否失效
    IsTokenStatus(token) {
      toknStatus({ token: token }).then((res) => {
        if (res.status == 1) {
          this.token = token;
        } else {
          var href = escape(window.location.href);
          var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
      // alert(url)
          window.location.href = url;
        }
      });
    },
    // 跳转首页
    toHref(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    toUrl(u) {
      this.$router.push(u);
    },
    change2: function (index) {
      this.num2 = index;
      if (index == 2) {
        this.onLoad2();
      }
    },
    handleSwitch(date) {
      //   this.year = date.year;
      //   this.month = date.month;
    },
    onChange(date) {
      this.date = date.format("YYYY-MM-DD");
      this.onRefresh();
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // 下拉加载
    onLoad() {
      this.getNewsList();
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news = [];
      that.page = 0;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getNewsList();
      setTimeout(() => {
        that.refreshing = false;
        // Toast("刷新成功");
        that.isLoading = false;
      }, 1500);
    },
    getNewsList() {
      var that = this;
      var news = this.news;
      var page = this.page + 1;
      var totalPages = this.totalPages;
      var param = {
        page: page,
        pageSize: 5,
        search_date: this.date,
      };
      if (totalPages >= page) {
        venueList(param).then((res) => {
          //////console.log(res);
          if (res.status == 1) {
            if (res.data.data.length < 4) {
              this.padding = false;
            }
            that.page = page;
            that.news = news.concat(res.data.data);
            that.totalPages = Math.ceil(
              Number(res.data.total) / res.data.data.length
            );
            if (res.data.data.length == 0) {
              //数据请求成功 但是无数据
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (that.news.length >= news.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            //登录失败
            // Toast(res.message);
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
    // 下拉加载
    onLoad2() {
      this.getNewsList2();
    },
    // 下拉刷新
    onRefresh2() {
      // 清空列表数据
      // 清空列表数据
      var that = this;
      that.news2 = [];
      that.page2 = 0;
      that.totalPages2 = 1;
      that.loading2 = false;
      that.finished2 = false;
      that.getNewsList2();
      setTimeout(() => {
        that.refreshing2 = false;
        // Toast("刷新成功");
        that.isLoading2 = false;
      }, 1500);
    },
    getNewsList2() {
      var that = this;
      var news = this.news2;
      var page = this.page2 + 1;
      var totalPages = this.totalPages2;
      var param = {
        page: page,
        pageSize: 10,
      };
      if (totalPages >= page) {
        venueList(param).then((res) => {
          //////console.log(res);
          if (res.status == 1) {
            if (res.data.data.length < 4) {
              this.padding = false;
            }
            that.page2 = page;
            that.news2 = news.concat(res.data.data);
            that.totalPages2 = Math.ceil(
              Number(res.data.total) / res.data.data.length
            );
            if (res.data.data.length == 0) {
              //数据请求成功 但是无数据
              that.finished2 = true;
              that.loading2 = false;
              return false;
            }
            if (that.news2.length >= news.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading2 = false;
              }, 1500);
            }
          } else {
            //登录失败
            // Toast(res.message);
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished2 = true;
      }
    },
    toInfo(id, t) {
      // console.log(888)
      this.$router.push({
        path: "/noticeInfo",
        query: {
          id: id,
          type: t,
        },
      });
    },
    toOrder(id) {
      this.$router.push({
        path: "/order",
        query: {
          id: id,
          date: this.date,
        },
      });
    },
  },
};
</script>
<style scoped>
.nav {
  position: fixed;
  width: 100%;
  z-index: 2;
}
.m-calendar,
.showChang {
  overflow: hidden;
  width: 100%;
}
.top-img img {
  width: 100%;
  display: block;
}
ul {
  height: 2rem;
  width: 100%;
  /* margin: 0 auto; */
  position: fixed;
  /* top: 90px; */
  z-index: 10;
  background: #f7f7f7;
  padding-bottom: 1rem;
  color: #d0d4d2;
  top: 2.5rem;
}
/* .content {
  padding-top: 4rem;
} */
ul li {
  float: left;
  width: 50%;
  height: 3rem;
  line-height: 3rem;
  border-color: #000;
  cursor: pointer;
  /* margin-top: 0.8rem; */
  font-size: 1.1rem;
  position: relative;
  /* font-weight: bold; */
  box-shadow: 0px 1px 3px 0px #e7e7e7;
}
/* */
.content {
  padding-top: 5.5rem;
}
.current {
  background: #F2AC20;
  color: white;
  box-shadow: 0px 1px 3px 0px #eccc82;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* .move-enter,
.move-leave-to {
  transform: translateY(10px) rotate(360deg);
} */

.move-enter-active,
.move-leave-acitve {
  transition: all 1s;
}
.venue-list {
  display: flex;
  padding: 1rem;
  height: 6.5rem;
  /* margin-bottom: 1rem; */
  box-shadow: 0px 0px 3px 0px #ccc9c9;
  margin-bottom: 0.3rem;
}
.date {
  color: #9ce17a;
  font-size: 0.9rem;
  text-align: right;
  padding-right: 0.5rem;
  height: 2rem;
  line-height: 2rem;
}
.venue-list-img {
  width: 40%;
}
.venue-list-img img {
  width: 100%;
  height: 100%;
}
.venue-list-text {
  width: 55%;
  margin-left: 5%;
  text-align: left;
}
.venue-list-tit {
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.venue-list-info {
  font-size: 0.9rem;
  margin: 0.5rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.venue-list-btn {
  background: #9ce17a;
  color: white;
  float: right;
  border-radius: 2rem;
  padding: 0 1rem;
  height: 2rem;
  line-height: 2rem;
}
.showChang {
  display: flex;
  flex-wrap: wrap;
}
.changList {
  width: 44%;
  margin-left: 4%;
  margin-top: 4%;
}
.changList-img {
  height: 6.5rem;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}
.changList img {
  width: 100%;
}
.venue-main {
  margin-bottom: 4.5rem;
}
.yu-btn {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
  height: 4rem;
  line-height: 4rem;
  box-shadow: 1px 0px 4px 1px gainsboro;
}
.yu-btn div {
  width: 50%;
  margin: 0 auto;
  height: 2.2rem;
  background: #F2AC20;
  line-height: 2.2rem;
  margin-top: 0.9rem;
  color: white;
  border-radius: 2rem;
  font-size: 1.1rem;
}
</style>


// WEBPACK FOOTER //
// src/page/venue.vue